/* © CNES */
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../../context/ConfigContext';

/**
 * Toast to display warning that Results are too numerous to be shown on map.
 * @param isFiltersVisible is Filters View is Visible.
 * @param maxFeatures maximum Features to display in Toast.
 * @returns Element.
 */
export const TooManyFeaturesToast = ({
  isFiltersVisible,
  maxFeatures,
}: {
  isFiltersVisible: boolean;
  maxFeatures: number;
}) => {
  const context = useContext(ConfigContext);
  const toast = useRef<Toast>(null);
  const [didRunWithDelay, setDidRunWithDelay] = useState<boolean>(false);

  useEffect(() => {
    if (context.featuresCount > maxFeatures && !context.doNotShowAgain) {
      messageDisplay();
    }
    // eslint-disable-next-line
  }, [context.featuresCount, context.doNotShowAgain]);

  /**
   * Display message for toast.
   */
  const messageDisplay = () => {
    toast.current?.clear();
    if (!didRunWithDelay && isFiltersVisible) {
      setDidRunWithDelay(true);
      toast.current?.show({
        severity: 'warn',
        summary: 'Too many results :',
        detail: (
          <div>
            <span>
              Reduce the scope of your search to less than {maxFeatures} results
              to display tiles on the map
            </span>
            <Button
              label="Don't show again"
              text
              className="text-black p-1"
              onClick={handleDoNotShowAgain}
            ></Button>
          </div>
        ),
        life: 5000,
      });
    }
  };

  /**
   * set doNotShowAgain to true and hide toast
   */
  const handleDoNotShowAgain = () => {
    context.setDoNotShowAgain(!context.doNotShowAgain);
    toast.current?.clear();
  };

  return (
    <Toast
      ref={toast}
      position="top-center"
      onHide={() => {
        setTimeout(() => {
          setDidRunWithDelay(false);
        }, 30000);
      }}
    />
  );
};
